// extracted by mini-css-extract-plugin
export var dropdownButton = "_3x-0";
export var fullWidthDropdownButton = "_3x-1";
export var icon = "_3x-3";
export var iconPlaceholder = "_3x-2";
export var menuItemRow = "_3x-9";
export var separator = "_3x-e";
export var shortcutContainer = "_3x-7";
export var shortcutContainerFilled = "_3x-8";
export var shortcutIconLg = "_3x-6";
export var shortcutIconMd = "_3x-5";
export var shortcutIconSm = "_3x-4";
export var submenuChevron = "_3x-d";
export var submenuDropdown = "_3x-a";
export var submenuTriggerRow = "_3x-b";
export var submenuTriggerRowOpen = "_3x-c";